import { useQuery } from "react-query";
import { fetchFinalValuationData } from "./api";

export function useFinalValuation(filters, options={}) {
    return useQuery(["fetchFinalValuationData", filters], () => fetchFinalValuationData(filters), {
      staleTime: 60000 * 60, 
      ...options
    })
  }